import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #6e96c4;
  justify-content: space-between;
`

export const Label = styled.div`
  height: 27px;
  font-weight: 500;
  text-align: center;
`
